import React from 'react';

import Page from 'components/layouts/Page';
import DataIn from 'components/pagesComponents/landing/ForResearches/components/DataIn';
import Databases from 'components/pagesComponents/landing/ForResearches/components/Databases';
import FAQ from 'components/pagesComponents/landing/ForResearches/components/FAQ';
import Hero from 'components/pagesComponents/landing/ForResearches/components/Hero';
import HowMakes from 'components/pagesComponents/landing/ForResearches/components/HowMakes';
import MakeYourData from 'components/pagesComponents/landing/ForResearches/components/MakeYourData';
import Menu from 'components/pagesComponents/landing/Main/components/Menu';

import s from './ForResearches.module.scss';

const seo = {
  title:
    'Welltory for research - Heart rate variability (HRV) research and academic partnerships',
  description:
    'Welltory provides accurate HRV measurements to use with your studies. We are open for research partnerships, ready to deliver safe, secure and private data for all participants. ',
    canonical: 'https://welltory.com/for-research/',
};

export default function ForResearches(): JSX.Element {
  return (
    <Page withoutHeader fullFooter className={s.content} seo={seo}>
      <Menu />
      <Hero />
      <Databases />
      <DataIn />
      <MakeYourData />
      <HowMakes />
      <FAQ />
    </Page>
  );
}
